import $ from 'jquery';
import { getState, modifyState } from '~src/state';
import { stopCloneStamp } from '~core';

export const initCloneStamp = () => {
  const brushRadius = getState('cloneStampBrushRadius');
  const brushAlpha = getState('cloneStampBrushAlpha');
  const brushHardness = getState('cloneStampBrushHardness');
  $('#editor-image-clone-stamp-radius-slider').val(brushRadius);
  $('#editor-image-clone-stamp-alpha-slider').val(brushAlpha);
  $('#editor-image-clone-stamp-hardness-slider').val(brushHardness);

  $('body').on('input', '#editor-image-clone-stamp-radius-slider', () => {
    const brushRadius = $('#editor-image-clone-stamp-radius-slider').val();
    modifyState('cloneStampBrushRadius', brushRadius);
  });
  $('body').on('input', '#editor-image-clone-stamp-alpha-slider', () => {
    const brushAlpha = $('#editor-image-clone-stamp-alpha-slider').val();
    modifyState('cloneStampBrushAlpha', brushAlpha);
  });
  $('body').on('input', '#editor-image-clone-stamp-hardness-slider', () => {
    const brushHardness = $('#editor-image-clone-stamp-hardness-slider').val();
    modifyState('cloneStampBrushHardness', brushHardness);
  });

  // Progressive mode checkbox defaults to checked via markup
  $('body').on('change', '#editor-image-clone-stamp-progressive-toggle', () => {
    const progressive = document.getElementById(
      'editor-image-clone-stamp-progressive-toggle'
    ).checked;

    if (progressive) {
      window.CloneStamp.setMode(window.CloneStamp.MODE_PROGRESSIVE);
    } else {
      window.CloneStamp.setMode(window.CloneStamp.MODE_STAMP);
    }
  });

  $('body').on('mouseleave', '#clone-stamp-container', () => {
    const isCloneStampActive = getState('isCloneStampActive');
    if (!isCloneStampActive) {
      return;
    }

    window.CloneStamp.disableDrawing();
  });

  $('body').on('mouseenter', '#clone-stamp-container', () => {
    const isCloneStampActive = getState('isCloneStampActive');
    if (!isCloneStampActive) {
      return;
    }

    window.CloneStamp.enableDrawing();
  });

  $('body').on('click', '#editor-menu-abort-clone-stamp', () => {
    stopCloneStamp();
  });

  let metaPressed = false;

  function keydown(e) {
    const isCloneStampActive = getState('isCloneStampActive');
    if (!isCloneStampActive) {
      return;
    }

    if (e.code === 'MetaLeft' || e.code === 'OSLeft') {
      metaPressed = true;
      window.CloneStamp.clearSelection();
      window.CloneStamp.disableDrawing();
    }
  }

  function keyup(e) {
    const isCloneStampActive = getState('isCloneStampActive');
    if (!isCloneStampActive) {
      return;
    }

    if (e.code === 'MetaLeft' || e.code === 'OSLeft') {
      metaPressed = false;
      window.CloneStamp.enableDrawing();
    }
  }

  function mousedown(e) {
    const isCloneStampActive = getState('isCloneStampActive');
    if (!isCloneStampActive) {
      return;
    }

    if (!metaPressed) {
      return;
    }
    window.CloneStamp.addSelectionPoint(e);
  }

  window.addEventListener('keydown', keydown);
  window.addEventListener('keyup', keyup);
  window.addEventListener('mousedown', mousedown);
};
